export enum Color {
  WHITE = '#FFFFFF',
  BLACK = '#000000',
  LIGHT_BG = '#F9FAFB',
  DARK_BG = '#141414',
}
